<template>
  <v-dialog
    v-model="dialog"
    v-bind="$attrs"
  >
    <v-card>
      <v-toolbar color="title" dark flat short class="px-2">
        <v-toolbar-title>Verstuur overzicht naar atelier</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" icon><v-icon>fas fa-times</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="mt-12">

        <v-form @submit.prevent
          class="mt-6"
        >

          <v-select
            outlined
            v-model="mailStudio.supplier_id"
            :items="suppliers"
            item-value="id"
            item-text="company_name"
            :error-messages="mailStudioErrors.supplier_id"
            label="Atelier"
          ></v-select>

          <v-select
            outlined
            :disabled="!mailStudio.supplier_id"
            v-model="mailStudio.mail_template_id"
            :items="mailTemplates"
            item-value="id"
            item-text="description"
            label="Template"
            @change="selectTemplate"
            clearable
            clear-icon="fa-times"
          ></v-select>

          <v-text-field
            outlined
            v-model="mailStudio.subject"
            :error-messages="mailStudioErrors.subject"
            label="Onderwerp"
          ></v-text-field>


          <v-card
            class="mb-6"
            flat
            outlined
            @drop.prevent="dropFiles"
            @dragenter.prevent
            @dragover.prevent
          >

            <v-list-item
              dense
            >
              <v-list-item-content>
                Atelier.pdf
              </v-list-item-content>
            </v-list-item>


            <v-list-item
              v-for="(file, index) in mailStudio.attachments"
              :key="index"
              dense
            >
              <v-list-item-content>
                {{ file.name }} ({{ Math.round(file.size / 1024, 0) }} kB)
                <v-btn
                  absolute
                  top
                  right
                  style="margin-top:-10px"
                  icon
                  small
                  color="error"
                  @click.stop="removeFile(index)"
                ><v-icon small>fas fa-times</v-icon></v-btn>
              </v-list-item-content>
            </v-list-item>

            <div class="text-center">
              <v-btn
                outlined
                color="primary"
                class="my-3"
                depressed
                small
                @click="browseFiles()"
              >Bijlage toevoegen</v-btn>
            </div>

            <input
              ref="fileBrowser"
              type="file"
              multiple
              @change="addBrowsedFiles"
              hidden
            />

          </v-card>

          <editor-field
            v-model="mailStudio.body"
            :error-messages="mailStudioErrors.body"
          ></editor-field>
          

        </v-form>
      </v-card-text>

      <v-card-actions class="px-6 pb-8">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="px-5"
          large
          outlined
          depressed
          @click="dialog = false"
        >Annuleren</v-btn>
        <v-btn
          color="primary"
          class="px-5"
          large
          depressed
          @click="sendClick()"
        >Verzenden</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>

</template>


<script>
import { inject, ref, watch, getCurrentInstance } from 'vue'
import DatePicker from '@/components/DatePicker'
import EditorField from '@/components/EditorField'
import { readFileAsDataUrl } from '@/utils'


export default {
  components: {
    DatePicker,
    EditorField,
  },
  props: {
    value: Boolean,
  },
  setup(props) {
    const api = inject('api')
    const loader = inject('loader')
    const { proxy } = getCurrentInstance();

    const offerLineModel = inject('offerLineModel')
    const mailStudioModel = api.resource().model()

    const mailTemplates = api.resource('mail-templates').collection({ params: { filter: { type: 'studio' }}}).all()
    const suppliers = api.resource('suppliers').collection({ params: { filter: { is_studio: 1 }, sort: 'studio_sort_index' }}).all()


    loader.bindRef(mailStudioModel.isCreating)

    const dialog = ref()

    watch(() => props.value, val => {
      dialog.value = val
      if (val) {
        mailStudioModel.clear()
      }
    }, { immediate: true })

    watch(dialog, val => {
      proxy.$emit('input', val)
    })

    const { attributes: mailStudio, errors: mailStudioErrors } = mailStudioModel

    function addBrowsedFiles(event) {
      addFiles(event.target.files)
    }

    function addFiles(files) {
      files.forEach(file => {
        readFileAsDataUrl(file).then(data => {
          const attachments = mailStudioModel.getAttribute('attachments', [])
          attachments.push({
            name: file.name,
            size: file.size,
            type: file.type,
            data,
          })
          mailStudioModel.setAttribute('attachments', attachments)
        })
      })
    }

    function browseFiles() {
      proxy.$refs.fileBrowser.click()
    }

    function dropFiles(event) {
      addFiles(Array.from(event.dataTransfer.files))
    }

    function removeFile(index) {
      const attachments = mailStudioModel.getAttribute('attachments', [])
      attachments.splice(index, 1)
      mailStudioModel.setAttribute('attachments', attachments)
    }

    function selectTemplate(mailTemplateId) {
      // console.log(mailTemplates)
      loader.show()
      api.resource('mail-templates').get(`${mailTemplateId}/studio/${mailStudioModel.getAttribute('supplier_id')}/offer-line/${offerLineModel.getAttribute('id')}`).then(({ data: mailTemplate }) => {
        mailStudioModel.setAttributes({
          subject: mailTemplate.subject,
          body: mailTemplate.body,
        })
      }).finally(() => {
        loader.hide()
      })
    }

    function sendClick() {
      mailStudioModel.setResource(`offer-lines/${offerLineModel.getAttribute('id')}/mail-studio`)
      mailStudioModel.create().then(() => {
        proxy.$emit('update')
        dialog.value = false
      })
    }


    return {
      dialog,
      mailTemplates,
      suppliers,
      mailStudio,
      mailStudioErrors,
      addBrowsedFiles,
      browseFiles,
      dropFiles,
      removeFile,
      selectTemplate,
      sendClick,
    }


    
  },
}
</script>
